import { extractFiatDecimalPlaces } from './extractFiatDecimalPlaces'

const DEFAULT_CRYPTO_DECIMALS = 8

/**
 * Extract dynamic decimal places based on currency type
 * Ported from React Native version
 */
export function extractDynamicDecimalPlaces({
  currencyCode,
  shouldMaskStablecoinAsFiat = true,
}: {
  currencyCode?: string
  shouldMaskStablecoinAsFiat?: boolean
}): number {
  if (!currencyCode) return 2

  const normalizedCode = currencyCode.toUpperCase()

  // Check if it's a fiat currency
  const fiatCurrencies = [
    'USD',
    'EUR',
    'GBP',
    'AED',
    'SAR',
    'KWD',
    'BHD',
    'OMR',
    'JOD',
    'JPY',
    'KRW',
    'VND',
    'ISK',
    'CLP',
    'PYG',
    'UGX',
  ]
  const isFiduciary = fiatCurrencies.includes(normalizedCode)

  // Check if it's a stablecoin
  const stablecoins = ['USDT', 'USDC', 'DAI', 'BUSD']
  const isStablecoin = stablecoins.includes(normalizedCode)

  if (isFiduciary || (isStablecoin && shouldMaskStablecoinAsFiat)) {
    // For stablecoins masked as fiat, use USD decimal places
    const fiatCodeForStablecoin = isStablecoin ? 'USD' : normalizedCode
    return extractFiatDecimalPlaces(fiatCodeForStablecoin)
  }

  // For crypto currencies, return crypto decimal places
  return DEFAULT_CRYPTO_DECIMALS
}
